import React from 'react'
import Banner1 from "../../../assets/images/banner-1.png"
import Banner2 from "../../../assets/images/banner-2.png"
import UnderLine from "../../../assets/images/line.png"
import { Link } from 'react-router-dom'
import { config } from '../config'
import image from "../../../assets/images/bg/banner-bg.png"

const HomeBanner = ({data}) => {
    return (
        <div>
            <div className="rs-banner banner-main-home" style={{backgroundImage : `url('${data[0]?.imageUrl !== "" ? data[0]?.imageUrl : image}')`}}>
                <div className="banner-overlay"></div>
                <div className="container">
                    <div className="content-wrap">
                        <span className="sub-title wow fadeInDown" data-aos="fade-right" data-aos-duration="550">{data[0]?.subtitle}</span>
                        <h1 className="title wow fadeInLeft" data-aos="fade-right" data-aos-duration="480" >{data[0]?.title?.split(" ")[0]}</h1>
                        <h2 className="title-small wow fadeInLeft" data-aos="fade-right" data-aos-duration="480" >
                            <span className='d-block'> {data[0]?.title?.split(" ").slice(1).join(" ")}</span> </h2>
                        <div className="line-img mb-20 wow fadeInLeft" style={{width:"200px"}} >
                            <img src={UnderLine} alt="" />
                        </div>
                        <p className="description wow fadeInLeft homebanner" dangerouslySetInnerHTML={{__html : data[0]?.description}}>
                            
                        </p>
                        <div className="btn-part wow fadeInUp" >

                            <Link to={`${config.appUrl}services`} className="readon view" >View All Services</Link>
                        </div>
                    </div>
                </div>
                {/* <div className="banner-animate">
                    <div className="circle-animate big">
                        <img src={Banner1} alt="" />
                    </div>
                    <div className="circle-animate small">
                        <img src={Banner2} alt="" />
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default HomeBanner
